import { ShieldCheck, Sparkles, MapPin, CalendarClock, Users, Repeat, FileText } from "lucide-react";

const points = [
  { icon: ShieldCheck, title: "Professional & reliable", text: "Show-up on time, communicate clearly, deliver consistent results." },
  { icon: Sparkles, title: "Detail-oriented cleaning", text: "We sweat the small stuff so your space actually feels clean." },
  { icon: MapPin, title: "Locally owned in NWI", text: "Northwest Indiana family business — we live and clean where you do." },
  { icon: CalendarClock, title: "Flexible scheduling", text: "One-time, recurring or anything in-between. We work around you." },
  { icon: Users, title: "Homes, churches & offices", text: "Trusted by families, congregations and small businesses alike." },
  { icon: Repeat, title: "Recurring service available", text: "Weekly, bi-weekly or monthly — set it and forget it." },
];

export default function WhyChoose() {
  return (
    <section id="why" className="section bg-[#F8FAFC]">
      <div className="container-ss">
        <div className="max-w-2xl">
          <span className="pill mb-3">Why Choose Us</span>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            Why families & businesses across NWI <span className="text-[#1E3A8A]">choose S.S. Cleaning Solutions</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {points.map(({ icon: Icon, title, text }) => (
            <div
              key={title}
              className="ss-card p-6 flex gap-4 items-start"
              data-testid={`why-${title.toLowerCase().replace(/[^a-z]/g, "-")}`}
            >
              <span className="h-11 w-11 rounded-2xl bg-emerald-100 text-emerald-700 inline-flex items-center justify-center shrink-0">
                <Icon size={20} />
              </span>
              <div>
                <h3 className="font-display text-lg font-semibold text-slate-900">{title}</h3>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-3">
          <a href="#quote" className="btn-primary" data-testid="why-quote-btn">
            <FileText size={16} /> Request a Free Quote
          </a>
        </div>
      </div>
    </section>
  );
}
